import type { ProjectStatusEnum } from "@nlc/shared-types";

import { ProjectStatusBadge } from "@/features/shared/components/ProjectStatusBadge";

interface InfoRowStatusProps {
  label: string;
  status: ProjectStatusEnum | undefined;
}

export function InfoRowStatus({ label, status }: InfoRowStatusProps) {
  if (!status) return null;

  return (
    <div className="flex justify-between items-start py-2">
      <span className="text-sm font-medium text-gray-500 min-w-0 flex-shrink-0 mr-4">
        {label}
      </span>
      <div className="flex flex-wrap justify-end">
        <ProjectStatusBadge key={status} status={status} />
      </div>
    </div>
  );
}
